import 'intl';
import 'intl/locale-data/jsonp/en-GB';

import axios from 'axios';
import * as e6p from 'es6-promise';
import * as React from 'react';
import { hydrate, unmountComponentAtNode } from 'react-dom';
import { IntlProvider } from 'react-intl';
import { connect, Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import { configureStore } from './app/redux/store';
import App from './app';
import * as a11y from 'react-a11y';
// import * as injectTapEventPlugin from 'react-tap-event-plugin';
import { AppContainer } from 'react-hot-loader';
import { JobProvider } from 'react-jobs';
import { Modal } from 'react-overlays';
import AuthInterceptor from './app/helpers/AuthInterceptor';
import { IStore } from './app/redux/IStore';
import { IBrandingState } from './app/services/branding/models';
import { combineReducers } from 'redux';
// import * as ReactGA from 'react-ga';

// injectTapEventPlugin();

e6p.polyfill();

if (process.env.NODE_ENV === 'local') {
  a11y(React);
}

Modal.prototype.componentWillMount = function() {
  this.focus = () => null;
};

axios.defaults.baseURL = window.__API_URL__;

const rehydrateState = window.__JOBS_STATE__;
const history = createHistory();
const store = configureStore(
  history,
  window.__INITIAL_STATE__,
);
const state = store.getState();
const mountNode = document.getElementById('app');

/*if (false) {
  ReactGA.initialize('UA-110011014-1');

  history.listen((location, action) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  });
}*/

new AuthInterceptor(store).registerInterceptor();

let Client = ({Component, branding}) => {
  return (
    <IntlProvider locale={branding.locale} messages={branding.i18n}>
      <ConnectedRouter
        history={history}
      >
        <Component branding={branding} />
      </ConnectedRouter>
    </IntlProvider>
  );
};

Client = connect((state: IStore) => ({ branding: state.branding }))(Client);

const renderIt = (Component) => {

  return hydrate(
    <AppContainer>
      <JobProvider rehydrateState={rehydrateState}>
        <Provider store={store}>
          <Client Component={Component} />
        </Provider>
      </JobProvider>
    </AppContainer>,
    mountNode,
  );
};

renderIt(App);

if (module.hot) {
  module.hot.accept('./app', () => {
    const newApp = require('./app').default;

    setImmediate(() => {
      // Preventing the hot reloading error from react-router
      unmountComponentAtNode(mountNode);
      renderIt(newApp);
    });
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/client.tsx